//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'datePicker',
  props: {
    minAge: {
      default: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      years: null,
      month: null,
      date: null,
      data: {
        years: [],
        month: [],
        date: [],
      }
    };
  },
  created() {
      this.init()
  },
  methods: {
      setForm({years, month, date}) {
        this.years = years * 1
        this.month = month * 1
        this.date = date * 1
        // this.handleChange(true)
      },
      getForm() {
        if(!this.date || !this.month || !this.years) return null
        return {
          years: this.years,
          month: this.month,
          date: this.date
        }
      },
      getMonthDays(year, month, filter){
        var maxDate = new Date(year, month, 0),
            _temp = []
        for(let i = 1;i < maxDate.getDate() + 1;i++) {
            _temp.push(i)
        }
        this.data.date = filter ? this.ageFilter(2, _temp) : _temp
      },
      /**
       * @method handleChange 监听出生日期年月日变化
       * @param {Boolean} isCheck 若为true则检查当前年、月和日之间的关系(如：当前年份为闰年2月的天数变化)
       */
      handleChange(isCheck) {        
        let _date = new Date()
        if(isCheck) {          
          this.getMonthDays(this.years || _date.getFullYear(), this.month || (_date.getMonth() + 1))
          if(this.date > (this.data.date.length - 1)) this.date = this.data.date[this.data.date.length - 1]
        }
        // 当用户选择的年份为最小办理岁数界限值时
        if(this.minAge && this.years && (this.years === (_date.getFullYear() - this.minAge))) {
          // 重置年份对应月和日
          this.getMonth(true)
          this.getMonthDays(this.years || _date.getFullYear(), this.month || (_date.getMonth() + 1), true)          
          // 校验用户已选的月和日的值
          if(this.month && this.date) {
            if((this.month && (this.month > (_date.getMonth() + 1))) || (this.data && this.date > _date.getDate())) {
              this.month = ''
              this.date = ''
            }
          }
        }else {
          // 恢复非临界状态月和日的选项
          this.getMonth()
          this.getMonthDays(this.years || _date.getFullYear(), this.month || (_date.getMonth() + 1))
        }
        // emit选项
        if(this.years && this.month && this.date) this.$emit('input', `${this.years}-${this.month}-${this.date}`)
        this.$emit('change', {years: this.years, month: this.month, date: this.date})
      },
      /**
       * @method ageFilter 过滤用户设定的最小岁数年龄选项
       * @param {Number} type 需要被过滤的时间类型 0：年 1：月 2：日
       * @param {Array} params 需要被过滤的数组
       */
      ageFilter(type, params) {        
        let date = new Date(),
            _temp = []
        switch(type) {
          case 0:
            params.forEach(e=>{
              if(date.getFullYear() - this.minAge >= e) _temp.push(e) 
            })                        
          return _temp
          case 1:
            params.forEach(e=>{
              if(date.getMonth() + 1 >= e) _temp.push(e)
            })
          return _temp
          case 2:
            params.forEach(e=>{
              if(date.getDate() >= e) _temp.push(e)
            })
          return _temp
        }
      },
      getYears() {
        let years = [],
            _date = new Date()
        for(let i = 0;i < 100;i++) {
            years.push(_date.getFullYear() - i)
        }
        this.data.years = !this.minAge ? years : this.ageFilter(0, years)
      },
      getMonth(filter) {
        let month = []
        for(let i = 1;i < 13;i++) {
            month.push(i)
        }
        this.data.month = filter ? this.ageFilter(1, month) : month
      },
      /** 
       *  @method init 初始化下拉选项数据  
       */ 
      init() {
        let _date = new Date()    
        this.getYears()
        this.getMonth()
        this.getMonthDays(this.years || _date.getFullYear(), this.month || (_date.getMonth() + 1))  
      }
  }
};
